module.exports = __webpack_public_path__ + "static/media/countries.2325d819.png";